import { Component, Input } from "@angular/core";
import { IconComponent } from "@skylab-angular-shared/ui";

export type KsefViolationViewItem = {
    kind: 'error' | 'warning',
    label: string,
    details?: string
};

@Component({
    selector: 'skl-ksef-document-errors',
    imports: [IconComponent],
    template: `
        <div class="error-wrapper">
            @for (violation of data; track violation.label) {
                <div class="error">
                    <div class="error-icon">
                        <skl-icon name="exclamation-circle" [color]="violation.kind === 'error' ? 'error' : 'warning'"></skl-icon>
                    </div>
                    <div class="error-item">
                        <div class="error-label"> {{violation.label}}</div>
                        <div class="error-description">{{violation.details}}</div>
                    </div>
                </div>
            }
        </div>
    `,
    styles: [`
        .error-wrapper {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        .error {
            display: flex;
            line-height: 1;
            gap: 10px;
        }

        .error-icon {
            display: flex;
            flex-direction: column;
        }

        .error-item {
            display:flex;
            flex-direction: column;
            gap: 5px;
        }

        .error-description {
            color: var(--secondary-color-light);
            font-size: 14px;
            line-height: 1.3;
        }
    `],
})
export class KsefDocumentErrorsComponent {
    @Input() public data: KsefViolationViewItem[] = [];
}
